<template>
  <div class="fixed_page"  id="blurry">
    <div class="get-started">
      <div class="fixed_page">
        <h1 class="how_works_title">{{ getTranslations.visitor_visitor_header_how_it_works }}</h1>
        <div class="how_it_works_box">
          <h1> {{ getTranslations.visitor_how_it_works_register }} </h1>
          <img src="/static/images/how_it_works/Register0.svg">
          <p> {{ getTranslations.visitor_how_it_works_text }} </p>
        </div>
        <div class="how_it_works_box second">
          <h1> {{ getTranslations.visitor_how_it_works_play_game_and_win }} </h1>
          <img src="/static/images/how_it_works/Play.png" class="how_it_works_img">
          <p> {{ getTranslations.visitor_how_it_works_play_game_and_win_text }} </p>
        </div>
        <div class="how_it_works_box">
          <h1>{{ getTranslations.visitor_how_it_works_risk_points }}</h1>
          <img src="/static/images/how_it_works/Collect.png" class="how_it_works_img">
          <p> {{ getTranslations.visitor_how_it_works_risk_points_text }} </p>
        </div>
        <div class="how_it_works_box">
          <h1>{{ getTranslations.visitor_how_it_works_win_the_jackpot }}</h1>
          <img src="/static/images/how_it_works/Prizes.png" class="how_it_works_img">
          <p> {{ getTranslations.visitor_how_it_works_win_the_jackpot_text }} </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters } from 'vuex';

export default {
  name: 'howItWorksLoggedIn',
  mounted() {
    /* eslint-disable */
    $(window).scroll(function (event) {
      var scroll = $(window).scrollTop();
      if(scroll > 500) {
        $('.goto-top').fadeIn();
      }
      else {
        $('.goto-top').fadeOut();
      }
    });
    /* eslint-enable */
    this.$nextTick(() => {
      /* eslint-disable */
      // initAccordion
      $('.toggle-accordion').click(function(e) {
        e.preventDefault();
        let $this = $(this);
        $('.toggle-accordion').removeClass('show');

        if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $this.removeClass('show');
          $this.next().slideUp(350);
        } else {
          $this.parent().parent().find('li .inner').removeClass('show');
          $this.parent().parent().find('li .inner').slideUp(350);
          $this.next().toggleClass('show');
          $this.addClass('show');
          $this.next().slideToggle(350);
        }
      });
      /* eslint-enable */
    });
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/HowItWorksLoggedIn.vue